export const code = {
    "colors": {
      "text": "#393A34",
      "background": "#fff",
      "primary": "#e3116c"
    },
    "styles": {
      "CodeSurfer": {
        "tokens": {
          "comment prolog doctype cdata": {
            "color": "#999988",
            "fontStyle": "italic"
          },
          "namespace": {
            "opacity": 0.7
          },
          "string attr-value": {
            "color": "#e3116c"
          },
          "punctuation operator": {
            "color": "#393A34"
          },
          "entity url symbol number boolean variable constant property regex inserted": {
            "color": "#36acaa"
          },
          "atrule keyword attr-name selector": {
            "color": "#00a4db"
          },
          "function deleted tag": {
            "color": "#d73a49"
          },
          "function-variable": {
            "color": "#6f42c1"
          },
          "tag selector": {
            "color": "#00009f"
          }
        },
        "title": {
          // "backgroundColor": "#f6f8fa",
          "color": "#393A34"
        },
        "subtitle": {
          "color": "#d6deeb",
          "backgroundColor": "rgba(10,10,10,0.9)"
        },
        "pre": {
          "color": "#393A34",
        },
        "code": {
          "color": "#393A34",
        }
      }
    }
};

export const code2 = {
  ...code,
  "colors": {
    ...code.colors,
    "background": "rgb(243, 244, 246)",
  },
};

export const demo = {
    fonts: {
    //   body: '"Helvetica Neue", Helvetica, Arial, sans-serif',
    },
    fontSizes: [96, 96, 96, 96, 96, 42, 58, 64, 96],
    colors: {
      text: '#000',
      primary: '#f00',
    },
    styles: {
      root: {
        textAlign: 'left',
      },
      Slide: {
        display: 'block',
        textAlign: 'left',
      },
    },
};
  
export const deck = {
    googleFont: 'https://fonts.googleapis.com/css2?family=Titillium+Web:wght@300;400;700',
    fonts: {
      body: '"Titillium Web", sans-serif;',
    },
    colors: {
      text: '#000',
      background: '#fff',
      primary: '#f00',
    },
    styles: {
      root: {
        textAlign: 'left',
      },
      Slide: {
        display: 'block',
        textAlign: 'left',
      },
    },
};